const toNumber = (value) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : 0;
};

export const getCartItemDiscountPercent = (item) => {
  const explicit = toNumber(item?.total_discount ?? item?.discount ?? 0);
  if (explicit > 0) return Math.round(explicit);

  const price = toNumber(item?.price);
  const original = toNumber(item?.original_price);
  if (original > price && original > 0) {
    return Math.round(((original - price) / original) * 100);
  }

  return 0;
};

export const getCartItemOriginalPrice = (item) => {
  const price = toNumber(item?.price);
  const original = toNumber(item?.original_price);
  if (original > price) return original;

  const discountPercent = getCartItemDiscountPercent(item);
  if (discountPercent > 0 && price > 0) {
    return price / (1 - discountPercent / 100);
  }

  return null;
};

export const cartItemHasDiscount = (item) => getCartItemDiscountPercent(item) > 0;
